/* ============================================================================
 * Buy More, Save More — tier price reconciler (PDP + product cards)
 * ----------------------------------------------------------------------------
 * Prices are rendered server-side already at the cart's current tier
 * (snippets/price.liquid, whenever a caller passes wc_tier_aware:true — the
 * PDP price block and every product card do). So fresh / preview-theme loads
 * paint the correct discounted price with no jump.
 *
 * This script is the RECONCILER. Shopify full-page-caches storefront HTML and
 * the cart is not in the cache key, so a cached load can show a stale tier.
 * It subscribes to `wc:tier-updated` (wc-tier-controller.js, fed by a live
 * /cart.js fetch) and repaints EVERY tier-aware price on the page — the PDP
 * price + its "% OFF" badge, and every product-card price (collection,
 * search, related, "more by this artist", etc.). It also repaints live when
 * the customer changes their cart without leaving the page.
 *
 * Tier-aware price spans carry data-wc-base-cents (the true pre-discount
 * price). Always discount from that, never from an already-discounted value.
 *
 * It never paints with a null state — that would wipe correct server markup
 * back to base before the controller's first fetch resolves.
 *
 * Per-unit floor savings mirror wc-tier-controller.js + Shopify. USD assumed.
 * ========================================================================== */
(function () {
  'use strict';

  if (window.__wcTierPrice) return;
  window.__wcTierPrice = true;

  var EVENT_NAME = (window.WCTier && window.WCTier.EVENT_NAME) || 'wc:tier-updated';

  // Mirrors snippets/wc-price-shrink-cents.liquid: ".00" dropped, visible
  // cents wrapped in <span class="wc-price-cents"> for the type-shrink.
  function fmtCents(cents) {
    var d = Math.floor(cents / 100), c = cents % 100;
    var html = '<span class="wc-price-sym">$</span>' + d.toLocaleString('en-US');
    if (c === 0) return html;
    return html + '<span class="wc-price-cents">.' + (c < 10 ? '0' : '') + c + '</span>';
  }

  // Remove every injected compare-at strike (server- or JS-rendered) plus the
  // whitespace text node placed beside each — repaint re-derives them.
  function clearStrikes() {
    document.querySelectorAll('.wc-tier-compare').forEach(function (s) {
      var sp = s.nextSibling;
      if (sp && sp.nodeType === 3 && !sp.textContent.trim()) sp.remove();
      s.remove();
    });
  }

  // The PDP price block is the only price that re-renders in place (variant
  // change via Dawn's Section Rendering API). Collection cards don't.
  // In-place price re-renders to watch: the PDP price block (Dawn variant
  // swap) and the sticky ATC bar's price (its own variant-change rebuild).
  var observeNodes = [];
  (function () {
    var r = document.querySelector('.wc-price-row');
    var pw = r ? r.querySelector('[id^="price-"]') : null;
    if (pw) observeNodes.push(pw);
    var sp = document.querySelector('.sticky-atc-bar__price');
    if (sp) observeNodes.push(sp);
  })();
  var observer = observeNodes.length
    ? new MutationObserver(function () {
        var s = window.WCTier && window.WCTier.getState ? window.WCTier.getState() : null;
        if (s) paint(s);
      })
    : null;
  function armObserver() {
    if (!observer) return;
    observeNodes.forEach(function (n) {
      observer.observe(n, { childList: true, subtree: true });
    });
  }

  function paint(state) {
    var off = (state && state.off) || 0;
    if (observer) observer.disconnect();

    clearStrikes();
    document.querySelectorAll('.wc-tier-pct').forEach(function (p) { p.remove(); });

    document.querySelectorAll('[data-wc-base-cents]').forEach(function (el) {
      var base = parseInt(el.getAttribute('data-wc-base-cents'), 10) || 0;
      if (!base) return;
      // Per-unit floor savings — matches wc-tier-controller.js + Shopify.
      var shown = off > 0 ? base - Math.floor(base * off / 100) : base;
      var html = fmtCents(shown);
      if (el.innerHTML !== html) el.innerHTML = html;
      el.classList.toggle('wc-tier-discounted', off > 0);
      // Full-price item (no native compare-at) + discount → inject a strike
      // showing the original price. The gap to the price is the strike's
      // own margin-right (see .wc-tier-compare in theme.liquid).
      if (off > 0 && el.parentNode) {
        var root = el.closest('.price');
        var native = root && (
          root.classList.contains('price--on-sale') ||
          root.classList.contains('volume-pricing--sale-badge')
        );
        if (!native && root) {
          var s = document.createElement('s');
          s.className = 'price-item price-item--regular wc-tier-compare';
          s.innerHTML = fmtCents(base);
          el.parentNode.insertBefore(s, el);
        }
      }
      // "-X%" tier badge on product cards — sits after the price, before
      // the "X+ sold" badge. The compare-at strike is hidden on cards
      // (CSS), so this badge is the discount cue there.
      if (off > 0 && el.parentNode &&
          (el.closest('.card-information') || el.closest('.wc-price-row') ||
           el.closest('.sticky-atc-bar'))) {
        var pct = document.createElement('span');
        pct.className = 'wc-tier-pct';
        pct.textContent = '-' + off + '%';
        el.parentNode.insertBefore(pct, el.nextSibling);
      }
    });

    // PDP "% OFF" badge — absent on collection / search pages.
    var badge = document.querySelector('.wc-b3g3f-badge');
    if (badge) {
      // State A (tier unlocked): the "-X%" beside the price is the cue,
      // so hide the BUY-6 badge. State B (0-1 items): show it.
      badge.textContent = (badge.dataset && badge.dataset.wcBadgeDefault) || 'BUY 6, SAVE 50%';
      badge.hidden = off > 0;
    }

    armObserver();
  }

  // Repaint whenever the tier state changes (cart add/remove anywhere).
  document.addEventListener(EVENT_NAME, function (e) { paint(e.detail); });

  // Prices are already server-rendered at the cart's current tier. Reconcile
  // immediately only if the controller already has live state; otherwise
  // leave the server markup and wait for wc:tier-updated.
  armObserver();
  var s0 = window.WCTier && window.WCTier.getState ? window.WCTier.getState() : null;
  if (s0) paint(s0);
})();
